export enum DemandSteps {
    Overview,
    Positions,
    Topics,
    Participants,
    Feedback,
    /** The chain the demand belongs to (#2160): read only, nothing to fill in. */
    Documents,
}
